import useSWR from 'swr';

import { ISimpleListResponse } from 'utils/types';

import { fetcher } from './utils';

export interface IMetabaseCard {
  id: number;
  identifier?: string;
  card_id?: number;
  [key: string]: any;
}

const listFetcher = ({ url, params }: { url: string; params?: Record<string, any> }) =>
  fetcher({ url, params });

export const useMetabaseCardList = (
  params?: Record<string, any>,
  shouldFetch: boolean = true,
  cacheKey?: string | null
) => {
  const key = shouldFetch
    ? { url: '/v4/dash/metabase_cards', params, cacheKey: cacheKey || undefined }
    : null;
  const { data, isLoading, error, mutate, isValidating } = useSWR<
    ISimpleListResponse<IMetabaseCard>
  >(key, listFetcher);

  return { data: data?.data, isLoading, error, mutate, isValidating };
};
